query GetSentBroadcastCount {
    broadcasts(
        first: 1
        sort: NAME_ASC
        statuses: [SENT, SENDING, COMPARISON_SENDING, COMPARISON_WAITING, HALTED]
    ) {
        totalCount
    }
}
